






























































































import { types } from '../../store/types/types.js';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import GroupsList from '../groups/GroupsList.vue';
import { institutionRole } from '../../../shared/enums/institutionRole';
import UserProfile from '../users/UserProfile.vue';
import { profileService } from '../../../shared/services/api/profile.service';
import { InstitutionProfileModel } from '../../../shared/models/institutionProfile.model';
import { useUserProfileStore } from '../../../shared/stores';

export default {
  components: {
    UserProfile,
    GroupsList,
  },
  data: function () {
    return {
      showGroupList: false,
      showProfileSetting: false,
      institutionRole: institutionRole,
      userProfile: null as InstitutionProfileModel,
    };
  },
  computed: {
    ...mapGetters({
      isPreviewMode: types.GET_IS_PREVIEW_MODE,
      showGroupsDropdown: types.GET_SHOW_GROUPS_DROPDOWN,
      showMobileProfileDropdown: types.GET_SHOW_MOBILE_PROFILE_DROPDOWN,
    }),
    userProfileStore() {
      return useUserProfileStore();
    },
    profile() {
      return this.userProfileStore.institutionProfile;
    },
    isLoadingProfileContext() {
      return this.userProfileStore.isLoading;
    },
    isChild() {
      return this.userProfileStore.institutionRoles.includes(this.institutionRole.EARLY_STUDENT);
    },
  },
  mounted() {
    this.getProfileMasterData();
  },
  methods: {
    ...mapMutations({
      hideGroupDropdown: types.MUTATE_HIDE_GROUPS_DROPDOWN,
    }),
    ...mapActions({
      toggleHeaderDropdown: types.TOGGLE_HEADER_DROPDOWN,
    }),
    async getProfileMasterData() {
      const profileMasterData = await profileService.getProfileMasterData([this.profile.id]);
      this.userProfile = profileMasterData.institutionProfiles[0];
    },
    removeGroupDropdownOpen() {
      const transitionTime = 300;
      setTimeout(() => {
        document.querySelector('#aula-header').classList.remove('group-dropdown-open');
      }, transitionTime);
    },
    groupClick() {
      this.showGroupList = !this.showGroupList;
    },
    handleGroupOpen() {
      this.showGroupList = false;
      this.hideGroupDropdown();
      this.removeGroupDropdownOpen();
    },
    scrollToTopPage() {
      if (this.showGroupsDropdown) {
        document.querySelector('#aula-header').classList.add('group-dropdown-open');
      } else {
        this.removeGroupDropdownOpen();
      }
      document.querySelector('html').scrollTop = 0;
      document.querySelector('body').scrollTop = 0; // this apply for ios device
    },
  },
};
